import { DropdownOptions } from '@components/common/formControl/dropdown';
import { create } from 'zustand';

interface CMDIStore {
	selectedCMDI: string;
	setSelectedCMDI: (value: string) => void;
	cmdiOptions: DropdownOptions[];
	setCmdiOptions: (options: DropdownOptions[]) => void;
	cmdiValue: string;
	setCmdiValue: (value: string) => void;
	touched: boolean;
	setTouched: (touched: boolean) => void;
	error: string | null;
	setError: (error: string | null) => void;
}

export const useCMDIStore = create<CMDIStore>(
	(set): CMDIStore => ({
		selectedCMDI: '',
		setSelectedCMDI: (value: string): void => set({ selectedCMDI: value }),
		cmdiOptions: [{ id: 'all', value: 'All' }],
		setCmdiOptions: (options: DropdownOptions[]): void => set({ cmdiOptions: options }),
		cmdiValue: 'All',
		setCmdiValue: (value: string): void => set({ cmdiValue: value }),
		touched: false,
		setTouched: (touched: boolean): void => set({ touched }),
		error: null,
		setError: (error: string | null): void => set({ error }),
	})
);
